import React, { Component } from "react";
import axios from "axios";
import { getUser } from "../../../actions/session";
import { Notifications } from "../../common/notification";
import { ACCOUNT_TAB_STIR_SHAKEN } from "../../../config/rest_endpoints";

class GlobalUpdateSubjectBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      subject: "",
      note: "",
      isLoad: false,
      blockId: this.props.previousData.id || "",
      id: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmitChange = this.onSubmitChange.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      subject: newProps.previousData.stirShakenSubject,
      note: newProps.previousData.note,
      id: newProps.previousData.id,
    });
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmitChange() {
    const { subject, note, User, blockId, id } = this.state;

    if (!subject) {
      Notifications.notify("Subject field is required", "Error", "error");
      return;
    }

    const payload = {
      id,
      stirShakenSubject: subject,
      note,
    };

    this.setState({ isLoad: true });

    const headers = { Authorization: `Bearer ${User.token}` };

    axios
      .put(`${ACCOUNT_TAB_STIR_SHAKEN}`, payload, { headers })
      .then((res) => {
        this.setState({ isLoad: false });
        this.props.close();
        this.props.classListing();
        Notifications.notify(
          "Subject block updated successfully",
          "Success",
          "success"
        );
      })
      .catch((err) => {
        const message = err.response.data.message || "Update failed";
        this.setState({ isLoad: false });
        Notifications.notify(message, "Error", "error");
      });
  }

  render() {
    const { subject, note, isLoad } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label style={{ fontWeight: "400", fontSize: "16px" }}>
                Stir Shaken Subject
              </label>
              <input
                type="text"
                className="form-control"
                name="subject"
                value={subject}
                onChange={this.handleChange}
                placeholder="Enter subject"
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-group">
              <label style={{ fontWeight: "400", fontSize: "16px" }}>
                Note
              </label>
              <textarea
                className="form-control"
                name="note"
                value={note}
                onChange={this.handleChange}
                placeholder="Enter note"
                rows="4"
              />
            </div>
          </div>
        </div>

        <div className="row" style={{ borderTop: "1px solid #e9ecef" }}>
          <div className="col-md-12 text-right">
            <button
              type="button"
              className="btn btn-primary mt-3"
              disabled={isLoad}
              onClick={this.onSubmitChange}
            >
              {isLoad ? (
                <>
                  <i className="icon-spinner4 spinner mr-1"></i> Updating...
                </>
              ) : (
                <>
                  <i className="icon-pencil5 mr-1"></i> Update
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default GlobalUpdateSubjectBlock;
